<template>
    <section v-if="criticalCards.length" class="radar-critical-cards" :class="columnCountClass">
        <div class="radar-critical-cards__grid">
            <KPICard v-for="card in criticalCards" :key="card.toolCode + '-' + card.kpiKey" class="radar-critical-cards__card" :type="card.severity" :iconClass="card.icon" iconSize="l" :label="$t(card.labelKey)" :value="card.count" :total="card.total" :linkText="$t('config.sensor.filter_view')" linkIconClass="i-andy-external" @click="handleCardClick(card)" />
        </div>
    </section>
</template>

<script>
import KPICard from '@/components/domain/ui/KPICard.vue'

export default {
    name: 'RadarCriticalCards',
    components: {
        KPICard
    },
    props: {
        criticalCards: {
            type: Array,
            required: true
        },
        // Columnas del layout tablet/desktop (alineadas con los módulos)
        columnCount: {
            type: Number,
            default: 3
        }
    },
    computed: {
        columnCountClass() {
            const count = Math.min(Math.max(this.columnCount, 1), 3)

            return `radar-critical-cards--cols-${count}`
        }
    },
    methods: {
        handleCardClick(card) {
            if (!card.route) return

            this.$emit('card-click', card)
        }
    }
}
</script>

<style lang="scss" scoped>
.radar-critical-cards {
    @include display-flex();
    @include flex-direction(column);
    gap: 12px;
    width: 100%;

    &__title {
        margin: 0;
        color: $main-text;
        font-family: Avenir-Bold;
        font-size: 18px;
        line-height: 24px;
    }

    &__grid {
        display: grid;
        // Mobile: 2 columnas
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 12px;
        width: 100%;
        margin: 0 auto;
    }

    ::v-deep .radar-critical-cards__card {
        grid-column: span 1;
        flex: none;
        width: 100%;
        min-width: 0;
        max-width: none;
    }
}

@media (max-width: 767px) {
    .radar-critical-cards {
        // Solo en mobile: si hay una única card, ocupa las 2 columnas
        ::v-deep .radar-critical-cards__card:first-child:nth-last-child(1) {
            grid-column: span 2;
        }
    }
}

@media (min-width: 768px) {
    .radar-critical-cards {
        // Alineado con .radar-modules-container (N cols × max 425.33px, gap 16px)
        &__grid {
            gap: 16px;
            justify-content: center;
        }

        &--cols-1 &__grid {
            grid-template-columns: minmax(0, 425.33px);
        }

        &--cols-2 &__grid {
            grid-template-columns: repeat(2, minmax(0, 425.33px));
        }

        &--cols-3 &__grid {
            grid-template-columns: repeat(3, minmax(0, 425.33px));
        }
    }
}
</style>
